import { makeStyles } from "@material-ui/core";
import { colors } from "../../constants.js/colors";

const useStyles = makeStyles(() => ({
    upgradePlanButton: {
        borderColor: colors.gold.primary,
        color: colors.black,
        backgroundColor: colors.gold.primary,
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        fontWeight: 500,
        '&:hover': {
            borderColor: colors.gold.primary,
            backgroundColor: colors.white,
        }

    },
}));

export default useStyles;